export const links = {
  booking: 'https://cal.com/craig-thomas-f2ucgl/30min?overlayCalendar=true',
  linkedin: 'https://www.linkedin.com/in/craig-thomas-1450b66/',
  portrait:
    'https://uploadthingy.s3.us-west-1.amazonaws.com/8oFFmEna3CRhNnzzoDmmFQ/1545923747529.jpg',
}

export const navItems = [
  { label: 'How I Help', id: 'how-i-help' },
  { label: 'How I Work', id: 'how-i-work' },
  { label: 'Experience', id: 'experience' },
  { label: 'About', id: 'about' },
]

export const situations = [
  {
    title: 'An important initiative is stuck',
    body: 'The priority is clear, but progress keeps slipping. I help clarify decisions, establish ownership, and lead the work through implementation.',
  },
  {
    title: 'Your leadership team needs to work better together',
    body: 'Unclear roles, unresolved disagreements, or inconsistent follow-through are holding the organization back. I help leaders build shared expectations and more effective ways of working.',
  },
  {
    title: 'Your operations need to catch up',
    body: 'Growth or change has stretched the systems and habits that used to work. I help simplify processes, strengthen accountability, and connect daily work to organizational priorities.',
  },
  {
    title: 'You’re navigating a transition',
    body: 'A leadership change or shift in direction requires experienced support. I bring hands-on leadership while helping the team build the capacity for what comes next.',
  },
]

export const steps = [
  {
    number: '01',
    title: 'Find the real constraint',
    body: 'I listen, ask questions, and look at how work actually happens. Together, we identify where strategy, leadership, structure, or systems are limiting progress and decide what matters most.',
  },
  {
    number: '02',
    title: 'Work alongside your team',
    body: 'I take an active role in implementation: facilitating decisions, clarifying responsibilities, improving operations, and coaching leaders as the work moves forward. Where useful, I use AI and automation to accelerate analysis, prototyping, process improvement, and implementation.',
  },
  {
    number: '03',
    title: 'Build the capacity to carry it forward',
    body: 'We establish clear ownership, practical systems, and stronger leadership habits. Knowledge and responsibility transfer to your team throughout the engagement.',
  },
]

export const experience = [
  {
    org: 'Fully',
    title: 'Leading across the whole business',
    body: 'As COO and President, I helped lead Fully through more than 6x growth, international expansion, acquisition, and significant organizational change. My responsibilities crossed finance, sales, marketing, supply chain, logistics, people, and the systems connecting them. I built teams and operating infrastructure while also dealing with the problems that inevitably appear when a business is changing quickly. That breadth matters in my work today because consequential problems rarely belong to just one function. I’ve spent years looking across the whole organization, understanding the tradeoffs, and helping teams decide what needs to happen next.',
  },
  {
    org: 'Mission-Driven Organization',
    title: 'Diagnosing what mattered and leading the work through',
    body: 'I was initially brought in to strengthen executive alignment around strategy and execution. Early in the engagement, it became clear that the organization also needed stronger shared values and sharper language around its vision and mission. Soon after, I identified a deeper leadership issue in finance, helped the executive team work through the decision, and led the transition and replacement search. When a technology partner could not deliver the workplanning and budgeting system the organization needed, I stepped in and built the solution using AI. By the end of the engagement, the organization had stronger leadership, clearer alignment, and practical systems it could carry forward.',
  },
  {
    org: 'Consulting Engagements',
    title: 'Solving the issue that matters most',
    body: 'My other engagements start with the issue that is creating the most leverage or risk for the client, rather than a predetermined consulting playbook. I’ve helped owners work through cash pressure, pricing and profitability, operating structure, product economics, supplier relationships, leadership questions, and difficult strategic choices. In one business, the changes contributed to a projected roughly $600K improvement in annual profitability on about $5M in revenue. In another, product and supplier changes were projected to save more than $65K in the first year. The problems differ; the work starts by figuring out what matters most.',
  },
]
